<template>
  <div class="adv-order-transporters">
    <div v-if="getTransporters.length > 0" class="adv-order-transporters">
      <AdvOrderTransportersSingle v-if="getTransporters.length === 1" v-on:set-input="$emit('set-input', $event)" />
      <AdvOrderTransportersMultiple
        v-else
        v-on:set-input="$emit('set-input', $event)"
        v-on:input="$emit('input', $event)"
        v-on:change="$emit('change', $event)"
      />
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AdvOrderTransportersSingle from './AdvOrderTransportersSingle.vue'
import AdvOrderTransportersMultiple from './AdvOrderTransportersMultiple.vue'

export default {
  name: 'AdvOrderTransporters',
  components: {
    AdvOrderTransportersMultiple,
    AdvOrderTransportersSingle
  },
  data () {
    return {
      debounceTimer: null
    }
  },
  props: {
    country: { type: String, default: '' },
    county: { type: String, default: '' },
    postal: { type: String, default: '' },
    city: { type: String, default: '' },
    address: { type: String, default: '' }
  },
  watch: {
    country (val) {
      this.initTransporters()
      this.setSmartPointIsSelected(false)
      this.setSelectedSmartPoint(null)
    },
    county (val) {
      this.initTransporters()
    },
    postal (val) {
      clearTimeout(this.debounceTimer)
      this.initTransporters()
      this.debounceTimer = setTimeout(() => {
        this.getExternalTransporterCost()
      }, 1000)
    },
    city (val) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.getExternalTransporterCost()
      }, 1000)
    },
    address (val) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.getExternalTransporterCost()
      }, 1000)
    },
    cartTotalWithDiscount (val) {
      this.initTransporters()
    },
    cartProductWeightTotal (val) {
      this.initTransporters()
      this.getExternalTransporterCost()
    },
    getTransporters: {
      handler: function (transporters) {
        if (transporters.length === 1) {
          this.setSelectedTransporterId(transporters[0].transporter_id)
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'getTransporters',
      'cartTotalWithDiscount',
      'cartProductWeightTotal',
      'getSelectedTransporterExternalRate'
    ])
  },
  mounted () {
    this.initTransporters()
  },
  methods: {
    ...mapActions([
      'getTransporterData',
      'setSelectedSmartPoint',
      'getExternalTransporterCost'
    ]),
    ...mapMutations([
      'setSmartPointIsSelected',
      'setSelectedTransporterId'
    ]),
    initTransporters () {
      if (!this.country || !this.county || !this.postal) {
        return
      }

      this.getTransporterData({
        country: this.country,
        county: this.county,
        postal: this.postal,
        totalWithVat: this.cartTotalWithDiscount,
        weight: this.cartProductWeightTotal,
        city: this.city,
        address: this.address,
        serviceCode: this.getSelectedTransporterExternalRate?.productCode || null
      })
    }
  }
}
</script>
